module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/articles.json
// module id = 424
// module chunks = 56932394960959